class DropdownManager {
  constructor() {
    this.activeDropdown = null;
    this.activeTrigger = null;
    this.boundPairs = [];
    this.init();
  }

  init() {
    const triggers = document.querySelectorAll('[class*="-dropdown-trigger"]');
    
    triggers.forEach(trigger => {
      const triggerClass = Array.from(trigger.classList).find(cls => cls.includes('-dropdown-trigger'));
      if (!triggerClass) return;
      const interactiveTrigger = trigger.closest('.coco-nav-link') || trigger;
      
      const prefix = triggerClass.replace('-dropdown-trigger', '');
      const menuSelector = `.${prefix}-dropdown-menu`;
      const menu = document.querySelector(menuSelector);
      if (!menu) return;
      this.boundPairs.push({ trigger: interactiveTrigger, menu });

      if (interactiveTrigger.matches('button')) {
        interactiveTrigger.setAttribute('aria-expanded', 'false');
      }
      
      interactiveTrigger.addEventListener('mouseenter', () => {
        // Close all modals when hovering over navigation
        this.closeAllModals();
        
        this.showDropdown(menu, interactiveTrigger);
      });

      interactiveTrigger.addEventListener('focusin', () => {
        this.showDropdown(menu, interactiveTrigger);
      });

      interactiveTrigger.addEventListener('click', (event) => {
        // Keep Lookbook links as normal navigation.
        if (triggerClass.includes('lookbook-dropdown-trigger')) return;

        event.preventDefault();
        this.closeAllModals();

        const isCurrentOpen = menu === this.activeDropdown;
        if (isCurrentOpen) {
          this.hideDropdown(menu);
          return;
        }

        this.showDropdown(menu, interactiveTrigger);
      });

      menu.addEventListener('mouseleave', () => {
        this.hideDropdown(menu);
      });
    });

    document.addEventListener('click', (e) => {
      const isClickInsideDropdown = e.target.closest('[class*="-dropdown-menu"]') || 
                                   e.target.closest('[class*="-dropdown-trigger"]');
      if (!isClickInsideDropdown && this.activeDropdown) {
        this.hideDropdown(this.activeDropdown);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.activeDropdown) {
        this.hideDropdown(this.activeDropdown);
      }
    });
  }

  showDropdown(menu, trigger) {
    if (this.activeDropdown) {
      this.hideDropdown(this.activeDropdown);
    }

    menu.classList.remove('opacity-0', 'invisible', 'pointer-events-none', 'translate-y-2');
    menu.classList.add('opacity-100', 'visible', 'pointer-events-auto', 'translate-y-0');
    if (trigger) {
      this.setTriggerState(trigger, true);
      this.activeTrigger = trigger;
    }
    
    this.activeDropdown = menu;
  }

  hideDropdown(menu) {
    if (!menu) return;
    
    menu.classList.remove('opacity-100', 'visible', 'pointer-events-auto', 'translate-y-0');
    menu.classList.add('opacity-0', 'invisible', 'pointer-events-none', 'translate-y-2');
    this.boundPairs.forEach(({ trigger, menu: boundMenu }) => {
      if (boundMenu === menu) {
        this.setTriggerState(trigger, false);
      }
    });
    
    this.activeDropdown = null;
    this.activeTrigger = null;
  }

  setTriggerState(trigger, isActive) {
    if (!trigger) return;
    trigger.classList.toggle('is-active', isActive);
    if (trigger.matches('button')) {
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    }
  }

  closeAllModals() {
    // Close search modal
    const searchModal = document.querySelector('.search-modal');
    if (searchModal && searchModal.classList.contains('active')) {
      searchModal.classList.remove('active');
      const headerOverlay = document.querySelector('.header-overlay');
      if (headerOverlay) headerOverlay.classList.remove('color-background-1');
      document.body.classList.remove('overflow-hidden');
    }
    
    // Close account modal
    const accountModal = document.querySelector('#account-modal');
    if (accountModal && accountModal.classList.contains('active')) {
      accountModal.classList.remove('active');
      const headerOverlay = document.querySelector('.header-overlay');
      if (headerOverlay) headerOverlay.classList.remove('color-background-1');
    }
    
    // Close cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('active')) {
      cartDrawer.classList.remove('active');
    }
  }
}

if (!window.__cocoDropdownManagerInitialized) {
  window.__cocoDropdownManagerInitialized = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new DropdownManager();
    });
  } else {
    new DropdownManager();
  }
}
